(function () {
  const getStoreRoot = () => {
    try {
      const cartPath = new URL(window.routes?.cart_url || '/cart', window.location.origin).pathname;
      const rootPath = cartPath.replace(/\/cart\/?$/, '');
      return rootPath ? `${rootPath}/` : '/';
    } catch {
      return '/';
    }
  };

  const getMessages = (form) => ({
    empty: form?.dataset?.msgEmpty || 'Please enter a discount code.',
    invalid: form?.dataset?.msgInvalid || 'This discount code is not valid for your cart.',
    success: form?.dataset?.msgSuccess || 'Discount applied successfully.',
    remove: form?.dataset?.msgRemove || 'Remove discount',
    loading: form?.dataset?.msgLoading || 'Applying…',
  });

  const showFeedback = (container, type, message) => {
    if (!container) return;
    container.hidden = false;
    container.classList.remove(
      'cart-one15-summary__coupon-feedback--success',
      'cart-one15-summary__coupon-feedback--error'
    );
    container.classList.add(
      type === 'success'
        ? 'cart-one15-summary__coupon-feedback--success'
        : 'cart-one15-summary__coupon-feedback--error'
    );
    container.textContent = message;
  };

  const hideFeedback = (container) => {
    if (!container) {
      return;
    }
    container.hidden = true;
    container.textContent = '';
    container.classList.remove(
      'cart-one15-summary__coupon-feedback--success',
      'cart-one15-summary__coupon-feedback--error'
    );
  };

  const fetchCart = async () => {
    const root = getStoreRoot();
    const response = await fetch(`${root}cart.js`, { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Cart fetch failed');
    return response.json();
  };

  const escapeHtml = (value) =>
    String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');

  const isImageUrl = (url) => {
    if (!url || !/^https?:\/\//i.test(url)) return false;
    const lower = url.toLowerCase();
    return (
      /\.(jpe?g|png|webp|gif|heic)(\?|$)/i.test(lower) ||
      lower.includes('/uploads/') ||
      lower.includes('cdn.shopify.com') ||
      lower.includes('uploadly') ||
      lower.includes('uploadery') ||
      lower.includes('fileupload')
    );
  };

  const buildPropertyValueHtml = (value, key) => {
    const raw = String(value || '').trim();
    if (!raw) return '';

    if (/<img/i.test(raw)) {
      const images = [...raw.matchAll(/src=["']([^"']+)["']/gi)].map((match) => match[1]);
      if (images.length) {
        return images
          .map(
            (url) =>
              `<a href="${escapeHtml(url)}" class="cart-line-item-property__image-link" target="_blank" rel="noopener noreferrer"><img src="${escapeHtml(url)}" alt="" class="cart-line-item-property__image" loading="lazy" width="80" height="80"></a>`
          )
          .join('');
      }
    }

    return raw
      .split(/[\n,]+/)
      .map((part) => part.trim())
      .filter(Boolean)
      .map((url) => {
        if (isImageUrl(url)) {
          return `<a href="${escapeHtml(url)}" class="cart-line-item-property__image-link" target="_blank" rel="noopener noreferrer"><img src="${escapeHtml(url)}" alt="" class="cart-line-item-property__image" loading="lazy" width="80" height="80"></a>`;
        }
        if (/^https?:\/\//i.test(url) || url.includes('/uploads/')) {
          const label = url.split('/').pop() || url;
          return `<a href="${escapeHtml(url)}" target="_blank" rel="noopener noreferrer">${escapeHtml(label)}</a>`;
        }
        return escapeHtml(url);
      })
      .join('');
  };

  const shouldShowCartProperty = (key, value) => {
    const val = String(value || '').trim();
    if (!val) return false;
    if (!key.startsWith('_')) return true;
    if (/upload|file/i.test(key)) return true;
    return /https?:\/\//.test(val) || val.includes('/uploads/') || val.includes('<img');
  };

  const getCartPropertyLabel = (key) => {
    if (key.startsWith('_')) return 'Uploaded files:';
    return `${key}:`;
  };

  const syncCartUploadProperties = async () => {
    if (!document.querySelector('.cart-one15__list')) return;

    try {
      const cart = await fetchCart();

      cart.items.forEach((item, index) => {
        const row =
          document.querySelector(`[data-line-item-key="${item.key}"]`) ||
          document.getElementById(`CartItem-${index + 1}`);
        if (!row) return;

        const details = row.querySelector('.cart-one15__item-details');
        if (!details) return;

        const props = item.properties || {};
        const entries = Object.entries(props).filter(([key, value]) => shouldShowCartProperty(key, value));
        if (!entries.length) return;

        let propertiesBlock = details.querySelector('.cart-one15__item-properties');
        if (!propertiesBlock) {
          propertiesBlock = document.createElement('dl');
          propertiesBlock.className = 'cart-one15__item-properties mb-0';
          const plan = details.querySelector('.cart-one15__item-plan');
          details.insertBefore(propertiesBlock, plan || null);
        }

        propertiesBlock.innerHTML = '';

        entries.forEach(([key, value]) => {
          const html = buildPropertyValueHtml(value, key);
          if (!html) return;

          const wrap = document.createElement('div');
          wrap.className = 'cart-one15__item-property';

          const label = document.createElement('dt');
          label.className = 'cart-one15__item-property-label';
          label.textContent = getCartPropertyLabel(key);

          const valueEl = document.createElement('dd');
          valueEl.className = 'cart-one15__item-property-value';
          valueEl.innerHTML = html;

          wrap.append(label, valueEl);
          propertiesBlock.appendChild(wrap);
        });
      });
    } catch {
      // Ignore cart.js sync errors.
    }
  };

  const discountWasApplied = (cartBefore, cartAfter, code) => {
    const normalizedCode = code.toLowerCase();
    const codeEntry = cartAfter.discount_codes?.find((entry) => entry.code?.toLowerCase() === normalizedCode);

    if (codeEntry) {
      return codeEntry.applicable === true;
    }

    const beforeApps = cartBefore.cart_level_discount_applications?.length || 0;
    const afterApps = cartAfter.cart_level_discount_applications?.length || 0;
    const beforeDiscount = cartBefore.total_discount || 0;
    const afterDiscount = cartAfter.total_discount || 0;

    return afterApps > beforeApps || afterDiscount > beforeDiscount;
  };

  const getSectionsToRefresh = () => {
    const footer = document.getElementById('main-cart-footer');
    const items = document.getElementById('main-cart-items');
    const sections = [];

    if (footer?.dataset?.id) {
      sections.push({ id: 'main-cart-footer', section: footer.dataset.id, selector: '.js-contents' });
    }
    if (items?.dataset?.id) {
      sections.push({ id: 'main-cart-items', section: items.dataset.id, selector: '.js-contents' });
    }
    sections.push({ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });

    return sections;
  };

  const refreshCartSections = async () => {
    const sectionConfig = getSectionsToRefresh();
    const sectionKeys = sectionConfig.map((s) => s.section).join(',');
    const root = getStoreRoot();
    const url = `${root}cart?sections=${sectionKeys}&sections_url=${encodeURIComponent(window.location.pathname)}`;
    const response = await fetch(url, { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Section fetch failed');

    const sections = await response.json();

    sectionConfig.forEach((config) => {
      const html = sections[config.section];
      if (!html) return;

      const target =
        document.getElementById(config.id)?.querySelector(config.selector) ||
        document.getElementById(config.id);
      if (!target) return;

      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const source = parsed.querySelector(config.selector);
      target.innerHTML = source ? source.innerHTML : html;
    });

    await syncCartUploadProperties();
  };

  const applyDiscountCode = async (code) => {
    const root = getStoreRoot();
    const cartBefore = await fetchCart();

    await fetch(`${root}discount/${encodeURIComponent(code)}`, {
      method: 'GET',
      credentials: 'same-origin',
      redirect: 'follow',
    });

    const cartAfter = await fetchCart();
    return discountWasApplied(cartBefore, cartAfter, code);
  };

  const clearDiscountCodes = async () => {
    const root = getStoreRoot();
    await fetch(`${root}discount/`, {
      method: 'GET',
      credentials: 'same-origin',
      redirect: 'follow',
    });
  };

  const syncOrderNoteToCart = async () => {
    const textarea = document.querySelector('.cart-one15-summary__note-input[name="note"]');
    if (!textarea) return;

    const root = getStoreRoot();
    await fetch(`${root}cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      credentials: 'same-origin',
      body: JSON.stringify({ note: textarea.value }),
    });
  };

  const setFormLoading = (form, isLoading) => {
    const applyBtn = form?.querySelector('.cart-one15-summary__coupon-apply');
    const input = form?.querySelector('input[name="discount"]');
    if (applyBtn) {
      applyBtn.disabled = isLoading;
      applyBtn.classList.toggle('is-loading', isLoading);
    }
    if (input) {
      input.disabled = isLoading;
    }
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-cart-discount-form]');
    if (!form) return;

    event.preventDefault();
    const input = form.querySelector('input[name="discount"]');
    const code = input?.value?.trim();
    const feedback = form.closest('.cart-one15-summary__coupon')?.querySelector('[data-cart-discount-feedback]');
    const messages = getMessages(form);

    hideFeedback(feedback);

    if (!code) {
      showFeedback(feedback, 'error', messages.empty);
      input?.focus();
      return;
    }

    setFormLoading(form, true);

    try {
      const applied = await applyDiscountCode(code);

      if (!applied) {
        showFeedback(feedback, 'error', messages.invalid);
        return;
      }

      await syncOrderNoteToCart();
      await refreshCartSections();

      const newForm = document.querySelector('[data-cart-discount-form]');
      const newFeedback = document.querySelector('[data-cart-discount-feedback]');
      showFeedback(newFeedback, 'success', getMessages(newForm).success);
    } catch {
      showFeedback(feedback, 'error', messages.invalid);
    } finally {
      setFormLoading(form, false);
    }
  });

  document.addEventListener('click', async (event) => {
    const removeBtn = event.target.closest('[data-cart-discount-remove]');
    if (!removeBtn) return;

    event.preventDefault();
    const couponBlock = removeBtn.closest('.cart-one15-summary__coupon');
    const feedback = couponBlock?.querySelector('[data-cart-discount-feedback]');
    const form = document.querySelector('[data-cart-discount-form]');
    const messages = getMessages(form);

    removeBtn.disabled = true;

    try {
      await clearDiscountCodes();
      await syncOrderNoteToCart();
      await refreshCartSections();
      hideFeedback(feedback);
    } catch {
      showFeedback(feedback, 'error', messages.invalid);
    } finally {
      removeBtn.disabled = false;
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    syncCartUploadProperties();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        window.requestAnimationFrame(() => syncCartUploadProperties());
      });
    }

    document.addEventListener(
      'blur',
      (event) => {
        if (!event.target.matches('.cart-one15-summary__note-input[name="note"]')) return;
        syncOrderNoteToCart().catch(() => {});
      },
      true
    );

    document.addEventListener(
      'submit',
      (event) => {
        const form = event.target;
        if (!form || (form.id !== 'cart' && form.id !== 'cart-notification-form')) return;
        if (!document.querySelector('[data-cart-pickup-conflict]')) return;

        const submitter = event.submitter;
        if (
          form.id === 'cart-notification-form' ||
          submitter?.name === 'checkout' ||
          submitter?.getAttribute('form') === 'cart'
        ) {
          event.preventDefault();
        }
      },
      true
    );

    const params = new URLSearchParams(window.location.search);
    const discountParam = params.get('discount');

    if (!discountParam) return;

    const form = document.querySelector('[data-cart-discount-form]');
    const feedback = document.querySelector('[data-cart-discount-feedback]');
    const messages = getMessages(form);

    showFeedback(feedback, 'error', messages.invalid);

    const input = form?.querySelector('input[name="discount"]');
    if (input) {
      input.value = discountParam;
    }

    const cleanUrl = window.location.pathname + window.location.hash;
    window.history.replaceState({}, '', cleanUrl);
  });
})();
